export async function Encrypt(object) {
    try {
        if (typeof object === "object" && object !== null) {
            JSON.parse(JSON.stringify(object))
            for (const key in object) {
                object[key] = await EncryptData(object[key]);
            }
            return object;
        }
        return EncryptData(object)
    }
    catch (err) {
        console.error("[ERROR] Encryption Service failed: ", err);
    }
}

async function EncryptData(data) {
    try {
        const publicKeyBase64 = process.env.REACT_APP_PUBLIC_KEY;
        const publicKeyBinary = Uint8Array.from(atob(publicKeyBase64), c => c.charCodeAt(0));
        const publicKey = await window.crypto.subtle.importKey(
            "spki",
            publicKeyBinary.buffer,
            {
                name: "RSA-OAEP",
                hash: "SHA-256"
            },
            false,
            ["encrypt"]
        )
        /* ====================================== */
        const encryptedData = await crypto.subtle.encrypt(
            { name: "RSA-OAEP" },
            publicKey,
            new TextEncoder().encode(data)
        )
        /* ====================================== */
        return bufferToBase64(encryptedData)
    } catch (err) {
        console.error("[ERROR] Data encryption failed: ", err);
    }
}

function bufferToBase64(buffer) {
    try {
        const bytes = new Uint8Array(buffer);
        const binary = bytes.reduce((acc, byte) => acc + String.fromCharCode(byte), '');
        return btoa(binary);
    } catch (err) {
        console.error("[ERROR] Buffer to Base64 conversion failed: ", err);
    }
}
